import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";

/** Figma 5326:88300 — the three fields stack with a 12px gutter. */
export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[3]};
  width: 100%;
  min-width: 0;
`;
